import { GetterTree } from 'vuex';
import { State } from '@/stores/costcentres/state';

export class Getters implements GetterTree<State, any> {
    [key: string]: (state: State, getters: any, rootState: any, rootGetters: any) => any;

    public costCentres = (state: State) => state.costCentres;
}
